
import React from 'react';
import Layout from '@/components/Layout';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6 text-vegana-primary">Términos y Condiciones de Uso</h1>
        
        <Card className="mb-8">
          <CardContent className="pt-6">
            <div className="prose max-w-none">
              <div className="mb-6 text-sm text-gray-500">
                Última actualización: 7 de abril de 2025
              </div>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">Titular de la App:</h2>
                <p className="mb-4">
                  Ruth Medina Marza<br />
                  CIF: [añade si lo tienes]<br />
                  Domicilio fiscal: Onda, Castellón, España<br />
                  Email de contacto: <a href="mailto:info@guiavegana.es" className="text-vegana-primary">info@guiavegana.es</a>
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">1. Objeto</h2>
                <p className="mb-4">
                  La presente aplicación ("Guía Vegana") ofrece un servicio de planificación nutricional personalizado a través de menús veganos adaptados a las características físicas y objetivos de salud de cada usuario. El uso de la app implica la aceptación de estos Términos y Condiciones.
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">2. Condiciones de uso</h2>
                <p className="mb-4">
                  Los usuarios se comprometen a utilizar la app de forma lícita y adecuada. Se prohíbe el uso de la aplicación para fines fraudulentos, ilegales o contrarios a la buena fe.
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">3. Registro y veracidad de los datos</h2>
                <p className="mb-4">
                  Para acceder al servicio, el usuario debe proporcionar información real, completa y actualizada, incluyendo nombre, correo electrónico, peso, altura, objetivos y posibles alergias. La falsedad de los datos podrá implicar la suspensión de la cuenta.
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">4. Asesoramiento personalizado</h2>
                <p className="mb-4">
                  El contenido proporcionado se basa en asesoramiento nutricional personalizado, creado por profesionales del equipo de Guía Vegana. Sin embargo, la app no sustituye la consulta médica o el diagnóstico clínico individualizado.
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">5. Suscripciones y pagos</h2>
                <p className="mb-4">
                  El acceso a Guía Vegana se realiza mediante suscripción mensual, trimestral o anual. Las suscripciones se renuevan automáticamente salvo cancelación previa por parte del usuario. La cancelación puede realizarse directamente desde la app.
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">6. Propiedad intelectual</h2>
                <p className="mb-4">
                  Todo el contenido (recetas, menús, textos, imágenes y diseños) es propiedad de Ruth Medina Marza o sus licenciantes y está protegido por la normativa sobre propiedad intelectual. Queda prohibida su reproducción o uso no autorizado.
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">7. Limitación de responsabilidad</h2>
                <p className="mb-4">
                  Guía Vegana no se hace responsable del uso indebido de la app, ni de decisiones de salud tomadas exclusivamente con base en el contenido ofrecido. El usuario asume toda responsabilidad derivada del uso del servicio.
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">8. Modificaciones del servicio</h2>
                <p className="mb-4">
                  Guía Vegana se reserva el derecho de modificar, suspender o eliminar el servicio en cualquier momento y sin previo aviso, siempre garantizando el acceso a los servicios ya contratados.
                </p>
              </section>
              
              <section className="mb-8">
                <h2 className="text-xl font-semibold mb-4">9. Legislación y jurisdicción</h2>
                <p className="mb-4">
                  Estos términos se rigen por la legislación española. En caso de conflicto, las partes se someten a los juzgados y tribunales de Castellón.
                </p>
              </section>
              
              <div className="mt-8 text-center">
                <Link to="/" className="text-vegana-primary hover:underline">
                  Volver a Inicio
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default TermsAndConditions;
